import * as S from "./styles";
import { useRef } from "react";
import { useClock } from "../hooks/use-clock";
import LeftWrapper from "./components/breakTimerDisplay";
import CircularTimerContainer from "./components/circularTimer";
import RightDisplay from "./components/rightDisplay";
import AdVideo from "../../../component/AdVideo";
import { useCapture } from "../../../hooks/use-capture";
import { CaptureButton } from "../../../component/CaptureButton";
import { useCopyTournamentText } from "../../../hooks/use-copy-tournament-text";
import { Helmet } from "react-helmet";

const UserTimer2 = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { handleCapture } = useCapture();
  const { copyTournamentText } = useCopyTournamentText();
  const {
    timeInfo,
    userCount,
    reBuyInUserCount,
    entryUserCount,
    adOnUserCount,
    stack,
    avgStack,
    pub,
    coverImage,
    backgroundImage,
    isAd,
    setIsAd,
    data,
    getData,
    subPrizeFont,
  } = useClock();

  return (
    <>
      <Helmet>
        <title>{data?.title}</title>
      </Helmet>
      <S.UserTimeWrapper2 ref={containerRef}>
        {backgroundImage && (
          <S.TimerBackground backgroundImage={backgroundImage} />
        )}
        <LeftWrapper
          coverImage={coverImage}
          cafeName={pub?.cafeName}
          tournamentTitle={data?.title}
          timerInfo={timeInfo}
          subTitle={data?.subTitle}
          stack={stack}
          avgStack={avgStack}
          playerCounts={{
            userCount,
            reBuyInUserCount,
            entryUserCount,
            adOnUserCount,
          }}
        />
        <RightDisplay
          data={data}
          subPrizeFont={subPrizeFont}
        />
        <CircularTimerContainer
          timeInfo={timeInfo}
          data={data}
          currentLevel={timeInfo.currentLevel || data?.structure[0] || null}
          nextLevel={data?.structure[timeInfo.currentLevel?.ord || 1] || null}
          isGameStarted={!!data?.timerDto}
        />
        {isAd && (
          <AdVideo
            coverImage={coverImage}
            onClose={() => setIsAd(false)}
            data={data}
            timeInfo={timeInfo}
            stack={stack}
            avgStack={avgStack}
          />
        )}
      </S.UserTimeWrapper2>
      <CaptureButton
        onCapture={() => handleCapture(containerRef.current)}
        onCopyText={() => copyTournamentText(data, timeInfo)}
      />
    </>
  );
};

export default UserTimer2;
